import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { API_CLIENT_CONFIG } from '../core/api-client-config';
import {
  BotApiKey,
  Bot,
  CreateBotRequest,
} from '../models';

@Injectable({ providedIn: 'root' })
export class BotsApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = `${inject(API_CLIENT_CONFIG).apiBaseUrl}/api/admin/BackofficeBots`;

  getBots() {
    return this.httpClient.get<Bot[]>(this.baseUrl);
  }

  createBot(request: CreateBotRequest) {
    return this.httpClient.post<BotApiKey>(this.baseUrl, request).pipe(
      catchError((error) => {
        if (error.error === 'User with this email already exists') {
          return throwError(
            () => "L'indirizzo email specificato è già in uso.",
          );
        }
        return throwError(
          () =>
            "Si è verificato un errore inaspettato. Riprova più tardi o contatta l'assistenza tecnica.",
        );
      }),
    );
  }

  regenerateApiKey(id: string) {
    return this.httpClient.post<BotApiKey>(
      `${this.baseUrl}/${id}/regenerate-key`,
      {},
    );
  }

  revokeApiKey(id: string) {
    return this.httpClient.delete(`${this.baseUrl}/${id}/key`);
  }
}
